<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/mprotectt",
		    "name": "MProtectt"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>MProtectt</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60  d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
      </div>
    </div>
  </div>
</div>
<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img width="100%" src="assets/images/about-mobile-security/about-mobile-security1.webp" class="og_image_url"
              alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
            <!-- <div class="play-btn">
                      <a class="video-popup" href="https://www.youtube.com/watch?v=G_G8SdXktHg"><i
                              class="fa fa-play"></i></a>
                  </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <h2>Security Where You Need It The Most</h2>
            </div>
            <p>In today’s digital-first world, almost everything we do is tied to our smartphones. From waking up in the
              morning with an alarm and ordering a meal on a delivery app to executing banking transactions and
              communicating with our close friends and family. Naturally, your mobile device whether is home to your
              most important and confidential information. From your precious memories captured on the phone camera and
              your virtual life on social media to the data in your banking app and private communications on Whatsapp.
              Your phone holds more personal and private information than any other digital or non-digital device - your
              computer, your wallet or even all the paperwork in your wardrobe.</p>
            <p>While the convenience of a mobile device is unparalleled to any other modern technological tool, it comes
              with its own unique vulnerabilities that risk your emotional, physical and financial wellbeing.
              Safeguarding your smartphone is a priority - before any other device or any physical item and place.</p>
            <p>MProtectt offers you peace of mind with enhanced mobile security that is always-on and working tirelessly
              to safeguard you against any malicious threat out there. Protectt.ai state-of-the-art security cloud
              is always scanning the horizons of the internet for known and unknown threats to ensure your device stays
              updated with best-in-class security.</p>
            <!-- <p>MProtectt™ provides your business and employees the flexibility to operate anywhere and access email without containerization.</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->


<!-- Start Products Style-->
<div class="section-service section-pt section-pb-60">
  <div class="container">
    <div class="row  ">
      <div class="col-lg-12 ">
        <div class="section-title text-center">
          <span style="color: #da2b27;">Your Personal data is easily evident on mobile device. This can hamper your
            privacy and financial condition.</span>
          <h2>Your Personal Data is Everywhere </h2>
        </div>
      </div>
    </div>
    <div class="row  ">
      <div class="agency-thumb">
        <div class="thumb">
          <img src="assets/images/about-mobile-security/data1.webp"
            alt="Secure your Data and Digital Payments of your App">
        </div>
      </div>
    </div>

  </div>
</div>
<!-- End Products Style-->

<div
  style="background: linear-gradient(0deg,rgba(22, 62, 111, 0.1),rgba(22, 62, 111, 0.1)); background-position: center; background-repeat: no-repeat;"
  class="section-agency-benefit bg-gray section-pt section-pb-60">
  <div class="container mobilesecuritymatters">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="section-title text-center  ">
          <span style="color: #da2b27;">There could be potential mobile threats to a user.</span>
          <h2>MOBILE SECURITY MATTERS!</h2>
        </div>
      </div>
    </div>
    <div class="row text-center newcard">
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
            <img class="img-fluid" src="assets/images/about-mobile-security/digital_privacy.webp" alt="Real-Time,Always-On Security">
            <h3 class="text-center mt-2">Digital Privacy</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
            <img class="img-fluid" src="assets/images/about-mobile-security/digital_fraud.webp" alt="Real-Time,Always-On Security">
            <h3 class="text-center mt-2">Digital Fraud</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
            <img class="img-fluid" src="assets/images/about-mobile-security/ransomware.webp" alt="Real-Time,Always-On Security">
            <h3 class="text-center mt-2">Ransomware</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
            <img class="img-fluid" src="assets/images/about-mobile-security/malicious_apps.webp" alt="Real-Time,Always-On Security">
            <h3 class="text-center mt-2">Malicious Apps</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
            <img class="img-fluid" src="assets/images/about-mobile-security/device_hacking.webp" alt="Real-Time,Always-On Security">
            <h3 class="text-center mt-2">Device Hacking</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
          <img class="img-fluid" src="assets/images/about-mobile-security/Virus Attack.webp" alt="Real-Time,Always-On Security">
          <h3 class="text-center mt-2">Virus Attack</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
          <img class="img-fluid" src="assets/images/about-mobile-security/unsecured_internet.webp" alt="Real-Time,Always-On Security">
          <h3 class="text-center mt-2">Unsecured Internet</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6 mt-4">
        <div class="card mobile-security-cards">
          <div class="card-body">
          <img class="img-fluid" src="assets/images/about-mobile-security/wi-fi_threats.webp" alt="Real-Time,Always-On Security">
          <h3 class="text-center mt-2">Wi-Fi Threats</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Start Services -->

<div class="section-service">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="section-title text-center">
          <!-- <span style="color: #da2b27;">There could be potential mobile threats to a user.</span> -->
          <h2>MPROTECTT: A ONE STOP SOLUTION</h2>
        </div>
      </div>
    </div>
    <div class="container w-100">
      <div class="row  ">
        <div class="col-md-3 col-sm-6">
          <div class="service-box">
            <div class="service-icon yellow">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-trophy"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/1.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>AV Protection</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>AV Protection</h3>
              <p>Monitor and blocks mobile threats from any source.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="service-box">
            <div class="service-icon orange">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-anchor"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/2.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>Malicious App Protection</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>Malicious App Protection</h3>
              <p>Blocks malicious app to steal private information.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="service-box ">
            <div class="service-icon red">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-trophy"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/3.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>Wi-Fi Monitoring</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>Wi-Fi Monitoring</h3>
              <p>Secures Wi-Fi Connection.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="service-box">
            <div class="service-icon grey">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-paper-plane-o"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/4.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>Web Security</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>Web Security</h3>
              <p>Monitor and blocks malicious websites.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-3 col-sm-6">
          <div class="service-box">
            <div class="service-icon yellow">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-trophy"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/5.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>Privacy Score</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>Privacy Score</h3>
              <p>Provides privacy score to judge security of mobile device.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="service-box">
            <div class="service-icon orange">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-anchor"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/6.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>Breach Identification</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>Breach Identification</h3>
              <p>Notifies in real time about any breach.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="service-box ">
            <div class="service-icon red">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-trophy"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/7.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>Privacy Control</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>Privacy Control</h3>
              <p>Allows to control where to share private information.</p>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="service-box">
            <div class="service-icon grey">
              <div class="front-content mprotectt-servicebox">
                <!-- <i class="fa fa-paper-plane-o"></i> -->
                <img src="assets/images/about-mobile-security/final-icons/8.png"
                  alt="MProtectt is Mobile AntiVirus App providing security against Viruses, Malwares, Spywares, Web Security & Wi-Fi Security">
                <h3>Mobile Device Booster</h3>
              </div>
            </div>
            <div class="service-content">
              <h3>Mobile Device Booster</h3>
              <p>Improves performance of device via. Memory optimization & battery optimization.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Services -->

<div style="padding: 50px 0;" class="section-newsletter section-ptb bg_image mt-50 playstore">
  <div class="container">
    <div class="row newsletter-style-2 political-newsletter align-items-center">
      <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
        <div class="title">
          <h2>Available on Google Play Store.</h2>
        </div>
      </div>
      <div style="text-align: center;" class="col-xl-6 col-lg-5 col-md-12 col-sm-12 col-12">
        <a class="btn btn-rectangle get-in-touch" target="_blank"
          href="https://play.google.com/store/apps/details?id=ai.protectt.mprotectt_v2">Download</a>
      </div>
    </div>
  </div>
</div>